<template>


      <div class="card" style="border-radius: 5px; width:500px; display:inline-block;">
 
        <div class="card-content">
          <p>
            <b-message type="is-info" has-icon>
            {{isConfirmation}}されました
            </b-message>
          </p>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="releaseConfircation()">OK
          </a>
        </footer>
      </div>
   
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ModalConfirmationMarkdown',
  componentName: 'ModalConfirmationMarkdown',
  props: {
    isConfirmation: ""
  },
  data () {
    return {
    }
  },
  computed:{
      ...mapState("tools",["releaseContents", "draftTexts", "releaseTexts"]),
   },
  methods: {
    releaseConfircation () {
      console.debug('*** Start *** deleteChatBot')
  // console.debug('chatbotID: ' + chatbotID)
      // this.$store.dispatch('tools/getText')
    //   this.markdownConfirmationFlag = false
      var number = 0
      if(this.isConfirmation == "下書きに保存"){
        number = 2
      } else if (this.isConfirmation == "公開"){
        number = 1
      }
      this.$emit('contentsMessage', number)
    
    this.$parent.close()

    //   this.$store.dispatch('chatbot/deleteChatBot', { companyid: this.user.companyID, chatbotID: chatbotID })
      console.debug('*** End *** deleteChatBot')
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Release/ModalConfirmation.vue